module.exports = __webpack_public_path__ + "img/bikers_01.69fa1af0.jpg";